import {baseRequestService} from "../base.ts";
import {User} from "../../types/domain.ts";

export const usersGet = () => baseRequestService<User[]>({
    url: '/users',
    method: 'GET'
})